import React, { useState, useEffect } from 'react'

import { Message, Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanel from '../../ButtonPanel'
import ViewFormWidget from '../dynamicForm/ViewFormWidget'
import EditFormWidget from '../dynamicForm/EditFormWidget'
import HTMLWidget from '../../HTMLWidget'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { saveSubProjectName } from '../../../redux/actions/subProjectProposal'
import { SUB_PROJECT_ID } from '../../../constants/constants'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { doneLoading, startLoading } from '../../../utils/loading'
import { setAlertMessage } from '../../../utils/messageUtil'

export default function ProjectNameNewWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props

  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [reservedWords, setReservedWords] = useState()
  const [notiMsg, setNotiMsg] = useState()
  const [formSchema, setFormSchema] = useState(props.schema)

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveSubProjectName(subProjectId, request)
      if (response) {
        setFormSchema(response)
        setAlertMessage('success', SAVE_SUCCESS_MSG, setNotiMsg)
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG, setNotiMsg)
      }
    } catch (e) {
      console.log('error', e)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG, setNotiMsg)
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let values = []

    formSchema.objects?.forEach((e) => {
      values.push({
        key: e.id,
        name: e.name,
        value: data[e.name] || null,
        type: e.type,
      })
    })

    let request = {
      id: formSchema.id,
      values: values,
    }

    handleSave(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {/* <WarningMessage message={formSchema?.feedbackBySubject} /> */}

      {isEdit && showCommandButton ? (
        <EditFormWidget
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          reservedWords={reservedWords}
          setReservedWords={setReservedWords}
          style={{ marginTop: -20 }}
        />
      ) : (
        <ViewFormWidget schema={formSchema} style={{ marginTop: -20 }} />
      )}

      {formSchema.note && (
        <Message
          showIcon
          type="info"
          style={{ marginTop: 20 }}
          description={<HTMLWidget data={formSchema.note} />}
        />
      )}

      {showCommandButton && !mode && (
        <div className="right">
          <hr />
          {notiMsg && (
            <Message
              closable
              showIcon
              type={notiMsg.type}
              description={notiMsg.msg}
              onClose={() => setNotiMsg('')}
              style={{ marginBottom: 10 }}
              className="left"
            />
          )}

          <ButtonPanel
            isDisabled={isLoading || reservedWords}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || formSchema.header}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </div>
      )}
    </Panel>
  )
}
